export const SALESORDER_GET = 'SALESORDER_GET'
export const SALESLINE_ADD = 'SALESLINE_ADD'
export const SALESORDER_ADD = 'SALESORDER_ADD'
export const SALESLINES_CLEAR = 'SALESLINES_CLEAR'
export const SALESORDERS_CLEAR = 'SALESORDERS_CLEAR'
export const SALESLINES_GET = 'SALESLINES_GET'
export const SALESLINE_GET = 'SALESLINE_GET'
export const SALESLINE_UPDATE = 'SALESLINE_UPDATE'
export const SALESLINE_ADD_QTY = 'SALESLINE_ADD_QTY'
export const SALESLINE_INDEX = 'SALESLINE_INDEX'
export const SALESORDER_INDEX = 'SALESORDER_INDEX'
export const SALESORDER_SELECT = 'SALESORDER_SELECT'



// WEBPACK FOOTER //
// ./src/store/actions/salesOrder.js